<template>
  <v-container>
    <v-row>
      <v-col cols="12" md="12">
        <v-card class="mx-auto">
          <v-card-title>
            <v-spacer />
            <v-btn
              elevation="0"
              dark
              color="primary"
              class=""
              :disabled="checklistDialog"
              @click="checklistDialog = true"
            >
              <v-icon class="mr-2">mdi-format-list-bulleted-square</v-icon>
              Requirements
            </v-btn>
          </v-card-title>
          <v-tabs v-model="appTabs">
            <v-tabs-slider color="primary"></v-tabs-slider>
            <v-tab
              v-for="(item, i) in tabs"
              :key="i"
              class="app--tabs"
              :disabled="item.disabled"
            >
              <v-icon class="mx-2">{{ item.icon }}</v-icon>
              {{ item.title }}
            </v-tab>
            <v-tabs-items v-model="appTabs">
              <v-tab-item>
                <Bio @moveNext="move" />
              </v-tab-item>
              <v-tab-item>
                <AcademicsList />
              </v-tab-item>
              <v-tab-item>
                <Declaration />
              </v-tab-item>
            </v-tabs-items>
          </v-tabs>
          <v-divider />
          <v-card-actions>
            <v-btn
              v-if="appTabs !== 0"
              outlined
              color="deep-orange accent-4"
              class="app--buttons"
              @click="previous"
            >
              <v-icon class="mx-1">arrow_back</v-icon>
              Previous
            </v-btn>
            <v-spacer />
            <v-btn
              v-if="appTabs !== tabs.length - 1"
              outlined
              color="primary"
              class="app--buttons"
              @click="next"
            >
              Next
              <v-icon class="mx-1">arrow_forward</v-icon>
            </v-btn>
            <v-btn
              tile
              color="primary"
              class="app--buttons"
              v-if="appTabs === tabs.length - 1"
              @click="submit"
            >
              Submit
              <v-icon class="mx-2">assignment_turned_in</v-icon>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
    <application-checklist
      :checklistDialog="checklistDialog"
      v-on:close-dialog="closeDialog"
    />
  </v-container>
</template>

<script>
import Declaration from "../components/Declaration.vue";
import AcademicsList from "../components/academicsList.vue";
import Bio from "../components/bio.vue";
import ApplicationChecklist from "./ApplicationChecklist.vue";

export default {
  name: "ApplicationTabs",
  components: { Declaration, AcademicsList, Bio, ApplicationChecklist },
  data: function () {
    return {
      show: true,
      appTabs: null,
      checklistDialog: true,
    };
  },
  computed: {
    tabs() {
      return [
        {
          title: "Personal Information",
          icon: "account_circle",
          name: Bio.name,
          disabled: false,
        },
        {
          title: "Education",
          icon: "school",
          name: AcademicsList.name,
          disabled: true,
        },
        {
          title: "Declaration",
          icon: "mdi-file-sign",
          name: Declaration.name,
          disabled: true,
        },
      ];
    },
    application: function () {
      return this.$store.getters["Application/appGetters"]("application");
    },
    academics() {
      return this.$store.getters["Profile/academicsGetters"]("academics");
    },
  },
  methods: {
    next() {
      if (this.appTabs < this.tabs.length) {
        if (this.tabs[this.appTabs].name === Bio.name) {
          Event.$emit("editBioData");
        } else if (this.tabs[this.appTabs].name === AcademicsList.name) {
          this.academics.length === 0
            ? Event.$emit("ApiError", "Atleast One Qualification Is Required")
            : this.proceedNext();
        } else {
          this.proceedNext();
        }
      }
    },
    proceedNext() {
      this.appTabs += 1;
      this.tabs[this.appTabs].disabled = false;
      this.tabs[this.appTabs - 1].disabled = true;
    },
    previous() {
      this.appTabs -= 1;
      this.tabs[this.appTabs].disabled = false;
      this.tabs[this.appTabs + 1].disabled = true;
    },
    move(val) {
      if (val) {
        this.appTabs += 1;
        this.tabs[this.appTabs].disabled = false;
        this.tabs[this.appTabs - 1].disabled = true;
      }
    },
    submit() {
      this.$router.push({
        name: "Payments",
        params: {
          app: btoa(this.application["applicationID"]),
        },
      });
      // emit this event on declaration.
      Event.$emit("submitDeclaration");
    },
    verify() {
      this.$verify.show({
        title: "OTP Verification",
        onVerify: () => {
          this.$store.dispatch("Activation/verifyOtpCode");
        },
      });
    },
    closeDialog: function (val) {
      this.checklistDialog = val;
    },
  },
  // watch: {
  //   checklistDialog(val) {
  //     if (!val) return;

  //     setTimeout(() => (this.checklistDialog = false), 4000);
  //   },
  // },
};
</script>

<style>
.app--tabs {
  font-size: 16px;
  text-transform: none;
}
.tab {
  background: #f4f5fa;
}
.app--buttons > .v-btn__content {
  font-size: 16px;
  text-transform: none;
}
</style>
